import { IMyAvaliationsGet } from 'types/myAvaliationsGet';
import api from '../services/config/api';

type sn = string | number | any;
export interface IParams extends Record<string, sn> {
  size: number;
  formId: number | string;
  page?: number;
  pageable: boolean;
}
export const getMyAvaliations = (query: IParams) =>
  api.get<IMyAvaliationsGet>(`/lei-geral-protecao-de-dados/minhas-avaliacoes`, {
    params: query,
  });

// /lei-geral-protecao-de-dados/minhas-avaliacoes

export const getMyAvaliationExportExcel = (query: string) =>
  api.get(`/lei-geral-protecao-de-dados/minhas-avaliacoes/export-excel${query}`, {
    responseType: 'blob',
  });
